import { ClockRepo } from "@/modules/working_hours/domain/ClockRepo";
import { Clock } from "../domain/Clock";

interface ScreenData {
  clocks: Clock[];
  ui_loading: boolean;
}

export class LoadHistory {
  private repo: ClockRepo;
  private screen_data: ScreenData;

  constructor(repo: ClockRepo, screen_data: ScreenData) {
    this.repo = repo;
    this.screen_data = screen_data;
  }

  async load() {
    this.screen_data.ui_loading = true;
    this.screen_data.clocks = await this.repo.find_all();
    this.screen_data.ui_loading = false;
  }

  toggle_show_changes(clock: Clock) {
    (clock as any).ui_show_changes = !clock.ui_show_changes;
  }
}


